import React, { useState } from 'react'
import Modal from 'react-responsive-modal'
import Button from '../../components/Button'
import { useDispatch } from 'react-redux'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import { changePersonnelPassword } from '../../actions/personnel/password'

const modalStyles = {
  modal: {
    padding: '0',
    borderRadius: '4px',
    minWidth: '300px'
  }
}

const headerStyle = {
  backgroundColor: '#3689FF',
  padding: '8px 12px',
  borderBottom: '1px solid #ccc',
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
}

const contentStyle = {
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px'
}

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px'
}

const labelStyle = {
  minWidth: '140px',
  textAlign: 'right',
  fontSize: '14px'
}

const inputStyle = {
  flex: 1,
  width: '100%',
  padding: '4px 26px 4px 8px',
  border: '1px solid #ccc',
  borderRadius: '2px',
  boxSizing: 'border-box'
}

const inputWrapperStyle = {
  position: 'relative',
  flex: 1,
  display: 'flex',
  alignItems: 'center'
}

const eyeIconStyle = {
  position: 'absolute',
  right: '8px',
  cursor: 'pointer',
  color: '#85939F',
  fontSize: '16px'
}

const checkboxRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginLeft: '152px'
}

const footerStyle = {
  padding: '12px',
  borderTop: '1px solid #ccc',
  display: 'flex',
  justifyContent: 'center',
  gap: '8px'
}

export default function PasswordModal({ isOpen, onClose, mid }) {
  const dispatch = useDispatch()

  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [blocked, setBlocked] = useState(false)
  const [needChangePassword, setNeedChangePassword] = useState(false)
  const [error, setError] = useState('')
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const resetForm = () => {
    setNewPassword('')
    setConfirmPassword('')
    setBlocked(false)
    setNeedChangePassword(false)
    setError('')
    setShowNewPassword(false)
    setShowConfirmPassword(false)
  }

  const handleClose = () => {
    resetForm()
    onClose()
  }

  const handleSave = async () => {
    if (!newPassword) {
      setError('Введите новый пароль')
      return
    }
    if (newPassword !== confirmPassword) {
      setError('Пароли не совпадают')
      return
    }

    const data = {
      new_password: newPassword,
      confirm_password: confirmPassword,
      blocked: blocked ? 1 : 0,
      need_change_password: needChangePassword ? 1 : 0
    }

    const result = await dispatch(changePersonnelPassword(mid, data))

    if (result.success) {
      handleClose()
    } else {
      setError(result.message)
    }
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      center
      styles={{ modal: modalStyles.modal }}
      showCloseIcon={false}
    >
      <div style={headerStyle}>
        <span role="img" aria-label="key">🔑</span>
        <span>Новый пароль</span>
      </div>

      <div style={contentStyle}>
        <div style={rowStyle}>
          <label style={labelStyle}>Новый пароль:</label>
          <div style={inputWrapperStyle}>
            <input
              type={showNewPassword ? 'text' : 'password'}
              style={inputStyle}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            {showNewPassword
              ? <AiOutlineEyeInvisible style={eyeIconStyle} onClick={() => setShowNewPassword(false)} />
              : <AiOutlineEye style={eyeIconStyle} onClick={() => setShowNewPassword(true)} />}
          </div>
        </div>

        <div style={rowStyle}>
          <label style={labelStyle}>Подтверждение:</label>
          <div style={inputWrapperStyle}>
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              style={inputStyle}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {showConfirmPassword
              ? <AiOutlineEyeInvisible style={eyeIconStyle} onClick={() => setShowConfirmPassword(false)} />
              : <AiOutlineEye style={eyeIconStyle} onClick={() => setShowConfirmPassword(true)} />}
          </div>
        </div>

        <div style={checkboxRowStyle}>
          <input
            type="checkbox"
            checked={blocked}
            onChange={(e) => setBlocked(e.target.checked)}
          />
          <label>Учетная запись заблокирована</label>
        </div>

        <div style={checkboxRowStyle}>
          <input
            type="checkbox"
            checked={needChangePassword}
            onChange={(e) => setNeedChangePassword(e.target.checked)}
          />
          <label>Смена пароля при следующем входе</label>
        </div>

        {error && <div style={{ color: 'red', textAlign: 'center' }}>{error}</div>}
      </div>

      <div style={footerStyle}>
        <Button mode="bordered" onClick={handleSave}>Сохранить</Button>
        <Button mode="bordered" onClick={handleClose}>Закрыть</Button>
      </div>
    </Modal>
  )
}
